import { NgModule } from '@angular/core';
import { MultiLocationAnalyticsService } from './multi-location-analytics.service';
import { HostService } from './_generated/host.service';
import { AnalyticsApiService } from './_internal/index';

@NgModule({
  imports: [],
  providers: [AnalyticsApiService, HostService, MultiLocationAnalyticsService],
  declarations: [],
  exports: [],
})
export class MultiLocationAnalyticsModule {}
